import { z } from 'zod/v3';

export const AlgorithmFilterClauseValidFormDataSchema = z.object({
  algorithmId: z.number(),
  filterClause: z.string(),
});
